module.exports = {
  FilterSubjects: ['数', '语文', '英', '物理', '化', '生', '地', '历', '政', '思想品德', '思品', '理综', '理科综合', '文综', '文科综合'],
  ExactSubjects: ['数学', '语文', '英语', '物理', '化学', '生物', '地理', '历史', '政治', '政治', '政治', '理综', '理综', '文综', '文综'],
  SubjectTypeWen: {
    0: {
      name: '全科',
      shortName: '全'
    },
    1: {
      name: '语文',
      shortName: '语'
    },
    2: {
      name: '数学',
      shortName: '数'
    },
    3: {
      name: '英语',
      shortName: '英'
    },
    4: {
      name: '物理',
      shortName: '物'
    },
    5: {
      name: '化学',
      shortName: '化'
    },
    6: {
      name: '生物',
      shortName: '生'
    },
    7: {
      name: '政治',
      shortName: '政'
    },
    8: {
      name: '历史',
      shortName: '历'
    },
    9: {
      name: '地理',
      shortName: '地'
    },
    99: {
      name: '其他',
      shortName: '其他'
    }
  },
  LiveTeacherPhase: {
    1: '全部',
    2: '高中',
    3: '初中'
  },
  weekDay: {
    0: '周日',
    1: '周一',
    2: '周二',
    3: '周三',
    4: '周四',
    5: '周五',
    6: '周六'
  },
  couponType: {
    DISCOUNT: 1, // 支付红包
    TRY: 2 // 体验红包
  },
  useStudyCoin: {
    All: 1, // 使用全部学币抵扣
    Some: 2, // 使用指定数量学币
    None: 3 // 不使用学币
  },
  // 商品类型
  good: {
    MEMBERSHIP: 1, // 会员
    STUDYCOIN: 2, // 学币
    PRACTICE: 3, // 学习包
    LIVE_COURSE: 4, // 直播课程
    LIVE_COURSE_MEMBERSHIP: 5, // 爱云课畅听卡
    LIVE_COURSE_DEBIT_CARD: 6, // 直播课储值卡(直播卡)
    THIRD_EXAM_GOOD: 7, // 三方考试商品
    WRONG_COPIES_GOOD: 9, // 错题本
    POINT_MALL_GOOD: 10, // 积分商城
    FEED_GOOD: 11, // Feed栏目
    LIANBAO_TEHUI: 12, // 联报特惠
    EXAM_CTB: 21 // 错题本
  },
  couponTarget: {
    All: 0,
    Student: 1,
    Parent: 2
  },
  couponUseStatus: {
    Free: 1, // 可使用
    Pending: 2, // 正被占用
    Used: 3 // 已被使用
  },
  discountType: {
    FixValue: 1, // 固定数值
    FixRatio: 2 // 固定百分比
  },
  userType: {
    Student: 1,
    Parent: 2
  },
  videoType: {
    live: 1, // 看直播
    replay: 2 // 看回放
  },
  // 对应页面来源 redirect
  RedirectType: { // 当存在Path 时，不去取 name
    0: { // 个人中心 -- 绑定账号
      name: 'success@bind', // 对应路由内的name值
      path: '/bind/success',
      query: ['roleType', 'code'], // 可选，对应路由需要的参数
      register: true // 可选，为true时，登录页面显示注册按钮
    },
    1: { // 成绩查询
      name: 'report',
      path: '/report'
    },
    2: { // 个人中心 -- 我的课程
      name: 'myCourse',
      path: '/myCourse',
      register: true // 可选，为true时，登录页面显示注册按钮
    },
    3: { // 直播课 -- 所有课程
      path: '/list/all',
      name: 'courseList',
      register: true
    },
    4: { // 直播课 -- 免费课程
      path: '/list/free',
      register: true
    },
    5: { // 直播课 -- 往期精选
      path: '/list/past',
      register: true
    },
    6: { // 直播课程详情
      name: 'course',
      path: '/course',
      query: ['cid', 'ActivitiesReceive', 'activityId'],
      parent: true, // 直播详情进入登录时，仅展示家长端入口
      register: true
    },
    7: { // 课程主页
      name: 'mainCourse',
      path: '/mainCourse',
      register: true, // 可选，为true时，登录页面显示注册按钮
      query: ['cid']
    },
    8: { // 录播课程详情
      name: 'tapedDetail',
      path: '/tapedDetail',
      parent: true, // 录播详情进入登录时，仅展示家长端入口
      register: true, // 可选，为true时，登录页面显示注册按钮
      query: ['cid']
    },
    9: { // 录播视频 video
      name: 'tapedVideo',
      path: '/tapedVideo',
      register: true, // 可选，为true时，登录页面显示注册按钮
      query: ['cid', 'key']
    },
    10: { // 个人中心 -- 绑定成功,可优化掉
      name: 'success@bind',
      path: '/bind/success',
      register: true // 可选，为true时，登录页面显示注册按钮
    },
    11: { // 在线支付，已登录
      path: '/onlinePayment',
      register: true // 可选，为true时，登录页面显示注册按钮
    }
  },
  // 来源
  From: {
    // APP 邀请注册任务
    registerTask: 1
  },
  AnalysisListVisible: {
    // 可查看
    VISIBLE: 1,
    // 需购买
    BUY: 2
  },
  // 埋点统计相关
  TrackPoint: {
    // 统计数量, 以“1”开始
    quantity: {
      // 最新报告列表—成绩报告—考试成绩提分报告弹窗立即开通按钮
      reportDetail: 11,
      // 报告详情—购买能够获得权益弹窗—购买查看按钮
      paperAnalysis: 12,
      // 试题解析—只看错题按钮
      viewWrongItems: 13,
      // 试题解析—购买报告可查看错题弹窗—立即购买按钮
      buyAnalysis: 14,
      // 支付页-选择开通商品页单次报告立即支付按钮
      reportPayment: 15,
      // 支付成功—单次报告购买成功后查看报告按钮
      viewReportBuySueecss: 16,
      // 显示登录页面
      viewLogin: 1,
      // 显示历次报告列表页面
      viewReportList: 2,
      // 显示购买支付页
      viewPay: 4,
      // 支付成功-显示单次报告购买成功页
      reportBuySueecss: 5,
      // 成绩报告（未购买）
      clickBuyScore: 17,
      // 显示立即生成弹窗
      viewNowBuild: 21,
      // 显示报告详情页面
      viewReportDetail: 3,
      // 点击成绩分析样例中查看专属成绩分析
      clickViewAna: 18,
      // 报告详情底部查看我的专属成绩分析按钮
      clickViewAnaBottom: 19,
      // 显示购买能够获得权益弹窗
      viewBuyEquity: 22,
      // 显示只看错题弹窗
      viewOnlyMistakes: 23,
      // 分享出学生列表页,teacher代表教师端
      shareStudentListTeacher: 24,
      // 注册按钮
      registerButtonTeacher: 25,
      // 已注册按钮
      registeredButtonTeacher: 26,
      // 非微信环境注册并绑定学生按钮
      registerBindStudentsTeacher: 27,
      // 注册绑定成功页
      registerBindSuccessTeacher: 28,
      // 登录页
      loginPageTeacher: 29,
      // 登录按钮
      loginButtonTeacher: 30,
      // 微信环境注册并绑定学生按钮
      registerWxBindStudentsTeacher: 31,
      // 单科解析中查看专属分析悬浮按钮
      analysisBtn: 32,
      // 最新考试报告-考试成绩提分报告弹窗跳过按钮
      jumpReport: 33,
      // 查看单科时的悬浮按钮点击-购买能够获得权益弹窗跳过按钮
      getInterests: 34,
      // 成绩报告（已购买）
      reportHaveBuy: 35,
      // 最新考试报告热区
      hotBuyMembes: 36,
      // 最新考试报告底部点击立即开通按钮
      botBuyMembes: 37,
      // 会员购买页-会员购买确认支付按钮
      sureBuyMember: 38,
      // 支付页-选择开通商品选择单次报告
      singleReport: 39,
      // 支付页-选择开通商品页选择会员
      memberReport: 40,
      // 支付页-选择开通商品页会员立即支付按钮
      payMember: 41,
      // 支付成功-会员购买成功查看报告按钮
      viewMemberBuySueecss: 42,
      // 支付成功-会员购买成功页
      memberBuySueecss: 43,
      // 会员购买页，购买成功后查看报告按钮
      memberBuySueecssViewBtn: 44,
      // 直播课分享领折扣按钮
      shareDiscountBtn: 45,
      // 最新考试报告页
      newViewReportList: 46
    }
  }
}



// WEBPACK FOOTER //
// ./src/constants/enum.js